import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ExecutionItem} from '../execution-item';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {ExecutionStateEnum} from '../execution-state.enum';

@Component({
    selector: 'mydocma-stepper-execution-item-step',
    templateUrl: './execution-step-item.component.html',
    styleUrls: ['./execution-step-item.component.scss']
})
export class ExecutionStepItemComponent implements OnInit, OnDestroy {

    @Input()
    public item: ExecutionItem;

    public isProgressBarVisible = true;

    public isIconVisible = false;

    public ngOnInit() {
        this.item.state$
            .pipe(untilDestroyed(this))
            .subscribe(state => {
                this.isProgressBarVisible = true;
                this.isIconVisible = false;

                if (state === ExecutionStateEnum.Completed) {
                    this.isProgressBarVisible = false;
                    this.isIconVisible = true;
                }
            });
    }

    public ngOnDestroy() {
    }
}
